<template>
  <div class="payment-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t('general.action_record') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="dashboard">
            {{ $t('general.home') }}
          </router-link>
        </li>
        <li v-if="userType==='supplier'" class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/supplier/funders">
            {{ $tc('funders.finance',2) }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            v-if="userType==='supplier'"
            slot="item-title"
            :to="{ name: 'FunderFinance', params: { id: this.$route.params.funder_id }}">
            {{ $t('islamic_finance.title') }}
          </router-link>
          <router-link
            v-else-if="userType=='funder'"
            slot="item-title" to="/funder/islamic-finances">
            {{ $t('islamic_finance.title') }}
          </router-link>
          <router-link
            v-else-if="userType=='auditor'"
            slot="item-title" to="/auditor/islamic-finances">
            {{ $t('islamic_finance.title') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $tc('general.action_record', 2) }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div v-if="all_attachment_link" class="col-xs-2 mr-4">
          <a :href="`${all_attachment_link}`" target="_blank" class="btn btn-primary" outline color="theme">
            Print All Attachments
          </a>
        </div>

        <div class="col-xs-2 mr-4">
          <a href="#" class="btn btn-outline-primary" outline color="theme" @click.prevent="downloadAllAttachments">
            Download All Attachments
          </a>
        </div>
      </div>
    </div>
    <single-funder-row v-if="userType=='supplier'" :fetch-data="fetchDataFunder"/>
    <single-islamic-finance-row :fetch-data="fetchData" />
    <SinglePreapprovedInvoiceRow v-if="showInvoice" :fetch-data="fetchInvoiceData"/>
    <table-component
      ref="table"
      :show-filter="false"
      :data="actionRecord"
      table-class="table"
    >
      <table-column
        :label="$t('invoices.date')"
        sort-as="invoice_date"
        show="formattedCreatedAt"
      />
      <table-column
        :label="$t('invoices.status')"
        sort-as="status"
      >
        <template v-if="row.status" slot-scope="row" >
          <span> {{ $t('invoices.status') }}</span>
          <span v-if="row.status ==='OFFER_TO_SELL_ACCEPT'" :class="'status-offer-to-sell-accept'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='OFFER_TO_SELL_REJECT'" :class="'status-offer-to-sell-reject'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='NOTICE_OF_DELIVERY_ISSUED'" :class="'status-offer-to-sell-delivery'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='AGENT_APPOINTED'" :class="'status-offer-to-sell-agent-appointed'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='SALE_CONFIRMED'" :class="'status-offer-to-sell-confirmed-sale'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='AGENCY_PENDING'" :class="'status-agency-pending'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='AGENCY_ACCEPTED'" :class="'status-agency-accepted'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='AGENCY_REJECTED'" :class="'status-agency-rejected'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='INVOICE_INFORMATION_ADDED'" :class="'status-offer-to-sell-invoice-info-added'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='INVOICE_VERIFIED'" :class="'status-offer-to-sell-invoice-verification'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else :class="'inv-status-'+row.status.toLowerCase()" v-html="row.status"/>
        </template>
      </table-column>
      <table-column
        :label="$t('general.company_name')"
      >
        <template slot-scope="row">
          <span> {{ $t('general.company_name') }}</span>
          <span> {{ row.company.name }}</span>
        </template>
      </table-column>
      <table-column
        :label="$t('general.attachments',2)"
      >
        <template slot-scope="row">
          <span> {{ $t('general.company_name') }}</span>
          <a v-if="row.attachments.length > 0" :href="`/islamic_finance/Attachment/${row.unique_hash}`" target="_blank" class="btn btn-outline-primary" outline color="theme">
            {{ $t('general.no_of_attachments') }} {{ row.attachments.length }}
          </a>
        </template>
      </table-column>
      <table-column
        :label="$t('general.actions',2)"
      >
        <template slot-scope="row">
          <a v-if="row.status !== 'DRAFT' && row.status !== 'AGENT_APPOINTED' && row.status !== 'INVOICE_INFORMATION_ADDED' " :href="`/download-islamic-finance/${$route.params.id}/offer/${row.status}`" target="_blank" class="btn btn-outline-primary" outline color="theme">
            {{ $t('general.download') }}
          </a>
        </template>
      </table-column>

    </table-component>
  </div>

</template>
<script>
import { mapActions } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import SingleIslamicFinanceRow from './SingleIslamicFinanceRow.vue'
import SingleFunderRow from '../funders/SingleFunderRow.vue'
import SinglePreapprovedInvoiceRow from '../preapprovedInvoices/SingleInvoiceRow.vue'
export default {
  components: {
    MultiSelect,
    SingleIslamicFinanceRow,
    SingleFunderRow,
    SinglePreapprovedInvoiceRow
  },
  mixins: [validationMixin],
  data () {
    return {
      fetchInvoiceData: [],
      userType: null,
      fetchData: [],
      actionRecord: [],
      fetchDataFunder: [],
      isLoading: false,
      financeAmount: 0,
      showInvoice: false,
      all_attachment_link: ''
    }
  },
  created () {
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
      this.loadFunder()
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') === 'auditor') {
      this.userType = 'auditor'
    }
    this.loadData()
    this.loadFinance()
  },
  methods: {
    ...mapActions('OfferToSell', [
      'SingleIslamicFinanceArray'
    ]),
    ...mapActions('funder', [
      'singleFunderArray'
    ]),
    ...mapActions('invoice', [
      'SingleInvoiceArray'
    ]),
    async downloadAttachment (id) {},
    async loadFunder () {
      let response = await this.singleFunderArray(this.$route.params.funder_id)
      this.fetchDataFunder = response.data.account
    },
    async loadData () {},
    async downloadAllAttachments () {
      try {
        // Mark as downloaded in background (also done by backend on GET, but keep explicit)
        window.axios.post('/api/offer_to_sells/mark-attachments-downloaded', { islamic_finance_id: this.$route.params.id }).catch(() => {})

        const attachmentsUrl = `/islamic_finance/Attachment/${this.$route.params.id}`
        const response = await window.axios.get(attachmentsUrl, { responseType: 'blob' })

        const disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition'])
        let filename = 'All-Attachments.zip'
        if (disposition) {
          const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i)
          if (match) {
            filename = decodeURIComponent(match[1] || match[2])
          }
        }

        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        // Fallback: navigate to the URL to let browser handle download
        window.location.href = `/islamic_finance/Attachment/${this.$route.params.id}`
      }
    },
    async loadFinance () {
      let response = await this.SingleIslamicFinanceArray(this.$route.params.id)
      if (response.data) {
        this.fetchData = response.data.islamicFinance
        this.financeAmount = this.fetchData[0].total
        if (this.fetchData[0].all_attachment_link) {
          this.all_attachment_link = this.fetchData[0].all_attachment_link
        }
        if (this.fetchData[0].funder_invoice && this.fetchData[0].funder_invoice.invoice && this.fetchData[0].total !== this.fetchData[0].funder_invoice.invoice.nominal_amount) {
          this.showInvoice = true
          let invoiceResponse = await this.SingleInvoiceArray(this.fetchData[0].funder_invoice.invoice.id)
          this.fetchInvoiceData = invoiceResponse.data.invoice
        }

        this.actionRecord = response.data.islamicFinance[0].islamic_finance_status
      }
    }

  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px !important;
}
</style>
